import DeleteIcon from "@mui/icons-material/Delete";
import { useDelete, useNotify, useRecordContext, useRedirect, useResourceContext } from "react-admin";
import ConfirmActionButton from "./ConfirmActionButton";

const DeleteConfirmButton = () => {
  const resource = useResourceContext();
  const record = useRecordContext();
  const notify = useNotify();
  const redirect = useRedirect();
  const [remove, { isPending }] = useDelete(
    resource,
    { id: record && record.id },
    {
      onSuccess: () => {
        notify(`${resource} deleted successfully`, { type: "success" });
        redirect("list", resource);
      },
      onError: () => {
        notify(`Error deleting ${resource}`, { type: "error" });
      },
    },
  );

  const handleDelete = () => {
    remove();
  };

  return (
    <ConfirmActionButton
      label="Delete"
      color="error"
      variant="text"
      startIcon={<DeleteIcon />}
      action={handleDelete}
      confirmTitle={`Delete ${resource} ID ${record && record.id}`}
      confirmContent="Are you sure you want to delete this item?"
      isPending={isPending}
    />
  );
};

export default DeleteConfirmButton;
